// ADD 2023.03.31 多言語化　@ci-inada START
  
    function translateDo(elm, lang) {
      const keys = Object.keys(lang).sort(function(a, b) {
        return b.length - a.length;
      });
      
      const descendants = elm.querySelectorAll('*');
      
      function translateTexts(elm, obj) {
        if(elm.textContent.length > 0 ) {
          for(let i in obj) {
            if(elm.textContent.match(obj[i])) {
              if(lang[obj[i]].match('\n')) {
                elm.innerText = elm.textContent.replaceAll(obj[i], lang[obj[i]]);
              } else {
                if(elm.classList != null && elm.classList.contains('cf-required')) {
                  elm.classList.remove('cf-required');
                  elm.classList.add('ci-required');
                }
                elm.textContent = elm.textContent.replaceAll(obj[i], lang[obj[i]]);
              }
              break;
            }
          }
        }
      }

      function translateSpiral(elm) {
        const children = elm.childNodes;
        children.forEach((child)=>{
          if(child.childElementCount > 0) {
            translateSpiral(child);
          } else if (child.textContent.trim().length > 0) {
            translateTexts(child, keys);
          }
        });
      }

      translateSpiral(elm);
      
    }

// ADD 2023.03.31 多言語化　@ci-inada END